export const CONFIG = {
  "PROJECTNAME": "pascha",
  "COMPANYNAME": "Pascha",
  "DFTLNGCODE": "de",
  "URL": "https://api.fbsshop.de",
  "PAYMENTSERVER": "https://stripe.mobiapi.de",
  "VENDORID": "10042001",
  "IMAGEURL": "/images",
  "PAYMENTSYSTEM": false,
  "BANNER": false,
  "BRANDS": false,
  "FLAG_ITEM_ON_HAND": false,
  "MENU_LOGO_BACKGROUND": false,
  "LOGO_LOGIN_BACKGROUND": false,
  "MENU_WHITE_BACKGROUND": false,
  "colors": {
    "primary": "rgb(227,6,19)",
    "primary100": "#F2CECC",
    "light": "rgb(227,6,19)",
    "secondary": "rgb(227,6,19)",
    "dark": "rgb(227,6,19)",
    "siteColor3": "#fff",
    "menuSecondary": "rgb(227,6,19)"
  }
};